"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 一个超级简单版本的 cloneDeep
 */
function cloneDeep(x, opts) {
    if (!x)
        return x;
    if (typeof x !== 'object')
        return x;
    /* istanbul ignore next */
    if (x instanceof RegExp) {
        return new RegExp(x.source, x.flags);
    }
    // ------------------------------
    // 接下来是对象相关的
    let ans;
    if (Array.isArray(x)) {
        ans = Array.from(x, item => cloneDeep(item, opts));
    }
    else {
        ans = {};
        Object.keys(x).forEach((key) => {
            const value = x[key];
            ans[key] = typeof value === 'object' && value !== null ? cloneDeep(value, opts) : value;
        });
    }
    if (opts && opts.freeze)
        Object.freeze(ans);
    return ans;
}
exports.default = cloneDeep;
